module.exports = __webpack_public_path__ + "static/img/samajuri (8).3c5ac5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (8).jpg
// module id = HKLN
// module chunks = 0